export const DEFAULT_THEME = "classic";

export const THEMES = [
  {
    id: "classic",
    name: "Classic",
    description: "Aviation cream and gold"
  },
  {
    id: "light",
    name: "Light",
    description: "White background, black text"
  },
  {
    id: "dark",
    name: "Dark",
    description: "Black background, white text"
  },
  {
    id: "black-on-white",
    name: "Black on White",
    description: "Pure black on white, no color"
  },
  {
    id: "white-on-black",
    name: "White on Black",
    description: "Pure white on black, no color"
  },
  {
    id: "night",
    name: "Night",
    description: "Amber text on black"
  },
  {
    id: "high-contrast",
    name: "High Contrast",
    description: "Maximum contrast"
  }
];

export function isValidTheme(id) {
  return THEMES.some(function(theme) {
    return theme.id === id;
  });
}
